import styles from './ProgressBar.module.scss';

interface ProgressBarProps {
  value: number;
  max: number;
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max,
  className,
}) => (
  <progress
    value={value}
    max={max}
    className={`${styles.progressBar} ${className}`}
  />
);
